import heroImage from "../assets/neha_dp_2.jpeg";
import logo from "../assets/neha_logo.png";
import Resume from "../assets/NEHA_NANDI_RESUME.pdf";

export default {
  heroImage,
  logo,
  Resume,
};
